import { useRoute, useRouter } from 'nuxt/app'
const previousPath = ref<string | null>(null)
export default () => {
  const route = useRoute()
  const router = useRouter()
  router.beforeEach((_, from, next) => {
    previousPath.value = from.fullPath || null
    next()
  })
  const path = computed(() => route.path)
  const tenantId = computed(() => route.params.tenantId)
  const phoneNumberId = computed(() => route.params.phoneNumberId)
  const threadId = computed(() => route.params.threadId)
  const campaignId = computed(() => route.params.campaignId)
  const eventId = computed(() => route.params.eventId)
  const hash = computed(() => route.params.hash)
  const query = computed(() => route.query)
  return {
    path,
    tenantId,
    phoneNumberId,
    threadId,
    campaignId,
    eventId,
    hash,
    query,
    previousPath
  }
}
